import { render } from "./manage-user.vue?vue&type=template&id=cc651ebe"
import script from "./manage-user.vue?vue&type=script&lang=js"
export * from "./manage-user.vue?vue&type=script&lang=js"

import "./manage-user.vue?vue&type=style&index=0&id=cc651ebe&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__